/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFileFromTemplateDto } from '../models';
// @ts-ignore
import type { FileMetaDataDto } from '../models';
// @ts-ignore
import type { OnlyOfficeControllerSaveFileForOnlyOfficeRequest } from '../models';
/**
 * OnlyOfficeApi - axios parameter creator
 * @export
 */
export const OnlyOfficeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFileFromTemplateDto} createFileFromTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onlyOfficeControllerCreateFileFromTemplate: async (createFileFromTemplateDto: CreateFileFromTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFileFromTemplateDto' is not null or undefined
            assertParamExists('onlyOfficeControllerCreateFileFromTemplate', 'createFileFromTemplateDto', createFileFromTemplateDto)
            const localVarPath = `/api/only-office/create-file-from-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileFromTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onlyOfficeControllerDownloadFileForOnlyOffice: async (fileId: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('onlyOfficeControllerDownloadFileForOnlyOffice', 'fileId', fileId)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('onlyOfficeControllerDownloadFileForOnlyOffice', 'token', token)
            const localVarPath = `/api/only-office/get-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {OnlyOfficeControllerSaveFileForOnlyOfficeRequest} onlyOfficeControllerSaveFileForOnlyOfficeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onlyOfficeControllerSaveFileForOnlyOffice: async (fileId: string, onlyOfficeControllerSaveFileForOnlyOfficeRequest: OnlyOfficeControllerSaveFileForOnlyOfficeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('onlyOfficeControllerSaveFileForOnlyOffice', 'fileId', fileId)
            // verify required parameter 'onlyOfficeControllerSaveFileForOnlyOfficeRequest' is not null or undefined
            assertParamExists('onlyOfficeControllerSaveFileForOnlyOffice', 'onlyOfficeControllerSaveFileForOnlyOfficeRequest', onlyOfficeControllerSaveFileForOnlyOfficeRequest)
            const localVarPath = `/api/only-office/save-file-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileId !== undefined) {
                localVarQueryParameter['fileId'] = fileId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onlyOfficeControllerSaveFileForOnlyOfficeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnlyOfficeApi - functional programming interface
 * @export
 */
export const OnlyOfficeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnlyOfficeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFileFromTemplateDto} createFileFromTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onlyOfficeControllerCreateFileFromTemplate(createFileFromTemplateDto: CreateFileFromTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetaDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onlyOfficeControllerCreateFileFromTemplate(createFileFromTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlyOfficeApi.onlyOfficeControllerCreateFileFromTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onlyOfficeControllerDownloadFileForOnlyOffice(fileId: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onlyOfficeControllerDownloadFileForOnlyOffice(fileId, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlyOfficeApi.onlyOfficeControllerDownloadFileForOnlyOffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {OnlyOfficeControllerSaveFileForOnlyOfficeRequest} onlyOfficeControllerSaveFileForOnlyOfficeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onlyOfficeControllerSaveFileForOnlyOffice(fileId: string, onlyOfficeControllerSaveFileForOnlyOfficeRequest: OnlyOfficeControllerSaveFileForOnlyOfficeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onlyOfficeControllerSaveFileForOnlyOffice(fileId, onlyOfficeControllerSaveFileForOnlyOfficeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnlyOfficeApi.onlyOfficeControllerSaveFileForOnlyOffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnlyOfficeApi - factory interface
 * @export
 */
export const OnlyOfficeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnlyOfficeApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateFileFromTemplateDto} createFileFromTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onlyOfficeControllerCreateFileFromTemplate(createFileFromTemplateDto: CreateFileFromTemplateDto, options?: RawAxiosRequestConfig): AxiosPromise<FileMetaDataDto> {
            return localVarFp.onlyOfficeControllerCreateFileFromTemplate(createFileFromTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onlyOfficeControllerDownloadFileForOnlyOffice(fileId: string, token: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.onlyOfficeControllerDownloadFileForOnlyOffice(fileId, token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {OnlyOfficeControllerSaveFileForOnlyOfficeRequest} onlyOfficeControllerSaveFileForOnlyOfficeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onlyOfficeControllerSaveFileForOnlyOffice(fileId: string, onlyOfficeControllerSaveFileForOnlyOfficeRequest: OnlyOfficeControllerSaveFileForOnlyOfficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.onlyOfficeControllerSaveFileForOnlyOffice(fileId, onlyOfficeControllerSaveFileForOnlyOfficeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnlyOfficeApi - object-oriented interface
 * @export
 * @class OnlyOfficeApi
 * @extends {BaseAPI}
 */
export class OnlyOfficeApi extends BaseAPI {
    /**
     * 
     * @param {CreateFileFromTemplateDto} createFileFromTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlyOfficeApi
     */
    public onlyOfficeControllerCreateFileFromTemplate(createFileFromTemplateDto: CreateFileFromTemplateDto, options?: RawAxiosRequestConfig) {
        return OnlyOfficeApiFp(this.configuration).onlyOfficeControllerCreateFileFromTemplate(createFileFromTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlyOfficeApi
     */
    public onlyOfficeControllerDownloadFileForOnlyOffice(fileId: string, token: string, options?: RawAxiosRequestConfig) {
        return OnlyOfficeApiFp(this.configuration).onlyOfficeControllerDownloadFileForOnlyOffice(fileId, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {OnlyOfficeControllerSaveFileForOnlyOfficeRequest} onlyOfficeControllerSaveFileForOnlyOfficeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnlyOfficeApi
     */
    public onlyOfficeControllerSaveFileForOnlyOffice(fileId: string, onlyOfficeControllerSaveFileForOnlyOfficeRequest: OnlyOfficeControllerSaveFileForOnlyOfficeRequest, options?: RawAxiosRequestConfig) {
        return OnlyOfficeApiFp(this.configuration).onlyOfficeControllerSaveFileForOnlyOffice(fileId, onlyOfficeControllerSaveFileForOnlyOfficeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

